<template>
  <div id="app" @click="clicked">
    <el-container class="is-vertical fullheight">
      <template v-if="!$route.meta.single">
        <el-header
          class="theme_color  no-print"
          v-if="$route.name && $route.name!='templateFormSingle' && $route.name != 'onlineForm'"
          height="48px"
          style="padding: 0 24px;border-bottom: rgb(10 34 62 / 8%) 1px solid;"
        >
        <navigator/>
        </el-header>
        <el-main  class="base-main" name="app-base-main">
          <div class="indexMenu">
            <div id="hymenu" style="width:64px;background: #FFFFFF;border-radius: 0px 0px 0px 0px;opacity: 1;box-shadow: 0px 2px 8px 0px rgba(6,27,57,0.08);" :style="hymenu">
              <menus />
            </div>
            <div id="hycontent" :style="conheight" style="display: contents;">
              <router-view v-if="isRouterAlive" style="margin: 0 auto;height: 100%;" class="indexMain" />
            </div>
          </div>
        </el-main>
      </template>
      <router-view v-if="$route.meta.single" />
    </el-container>
  </div>
</template>
<script>
import Navigator from "@/views/Navigator.vue";
import Menus from "@/views/menus.vue";
import { mapState, mapActions } from "vuex";
import utils from "@/utils.js";


export default {
  name: "app",
  components: {
    Navigator,
    Menus
  },
  data() {
    return {
      isRouterAlive: true,
      lastTime: new Date().getTime(), // 最后一次点击的时间
      currentTime: new Date().getTime(), //当前时间
      overTime: 30 * 60 * 1000, //默认超时时间(30分钟)
      requestLock: false,
      conheight: { height: "",width:"" },
      hymenu: { height: window.innerHeight -48 + "px"},      
    };
  },
  mounted() {
    const this_ = this;
    //浏览器的两个选项卡之间通讯  原来的窗口监听发送的消息
    if (
      window.BroadcastChannel &&
      window.BroadcastChannel.constructor == Function
    ) {
      window.ch = new BroadcastChannel("unload");
      window.ch.addEventListener("message", function (e) {
        console.info(e.data);
        this_.$root.$emit("unload-handler");
      });
    }
    // 因为resize事件在整个项目中只能监听一次，所以这里通过全局广播发送这个事件
    window.onresize = () => {
      this.$root.$emit("resize");
    };
    this_.getRoute();
  },
  methods: {
    //页面高度
    getHeight() {
      this.conheight.height = window.innerHeight * 0.835 + "px";
      this.conheight.width = window.innerWidth -64  + "px";
    },
    getRoute (){
      this.$router.onReady(() => {//方法用于route未能完成加载无法获取route相关信息
        let array = ['agentStart','templateFormSingle','onlineForm','inst','defStart','templateReport','task','instStart','instRead-read','myRead-type','instRead','querySqlContent'];
        // alert(this.$route.name);
        if(array.indexOf(this.$route.name)<0){//展示左侧菜单栏目
          $("#hymenu").css("width","64px");
          $("#hymenu").show();
        }else{//隐藏左侧菜单栏目
          $("#hymenu").css("width","0px");
          $("#hymenu").hide();
        }
      });
    },
    reload() {
      this.isRouterAlive = false;
      setTimeout(() => {
        this.isRouterAlive = true;
      }, 10);
    },
    clicked() {
      this.lastTime = new Date().getTime(); //当界面被点击更新点击时间
    },
    checkTime() {
      if (sessionStorage.getItem("currentUser")) {
        let user = JSON.parse(sessionStorage.getItem("currentUser"));
        if (user && user.overTime) {
          let minute = parseInt(user.overTime);
          this.overTime = minute * 60 * 1000;
        }
      }
      this.currentTime = new Date().getTime();
      if (this.currentTime - this.lastTime > this.overTime) {//超时未操作自动退出登录
        if (sessionStorage.getItem("currentUser")) {
          // 退出登录
          this.$store.dispatch("login/logoutAndCleanUp").then(() => {
            this.$router.push({
              path: "/login",
            });
          });
        }
      }
    },
    // 同步当前请求地址到选中的目录（通过sessionStorage来设置选中的目录）
    syncCurrentMenuFromPath(route){
      // 1.如果当前已经有选中的目录
      console.log(sessionStorage.menu_alias);
      if(sessionStorage.menu_alias && sessionStorage.menu_alias !== 'home'){
        return;
      }
      //如果当前页面是由iframe加载的， 则不需要设置菜单别名
      if(window.self != window.top){
        return ;
      }
      const matched = route.matched;
      if(route.path && matched && matched.length > 0 ){
        sessionStorage.menu_path = route.path;
        sessionStorage.menu_alias = matched[0].path.replace("/", "");
      }
    }
  },
  computed: mapState({
    menus: (state) => state.menu.all,
    menuMaps: (state) => state.menu.menuMaps,
  }),
  watch: {
    menus: function (newVal) {
      utils.Menu.addSyncMenus(this, newVal);
    },
  }, 
  created() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    const that = this;
    that.$store._vm.$root.$on("login-completed", function (route) {
      if(!that.requestLock){
        that.requestLock = true;
        setTimeout(()=>{
          that.requestLock = false;
        },5000)       
        // 登录完成以后，同步当前路径到选中的目录菜单
        that.syncCurrentMenuFromPath(route);
        // 获取静态资源目录
        that.$store.dispatch("menu/getStaticMenus");
        // 获取用户接口权限
        that.$store.dispatch("menu/getCurrentUserMethodAuth");
        // 获取动态资源目录
        that.$store.dispatch("menu/getSyncMenus");
      }
    });
    //定时触发判断是否未点击
    window.setInterval(this.checkTime, 30000);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

// /deep/ .el-main{
//   overflow: hidden !important;
// }

/deep/ .el-container{
  background: #ffffff;
  // padding-left: 16px;
  // padding-top: 16px;
  // padding-right: 16px;
  // padding-bottom: 16px;

}

/deep/ .appcenter{
  background: #F0F2F5 !important;
  // padding-right: 16px !important;
  // padding-bottom: 16px !important;
  // padding-left: 16px !important;
}
/deep/ .el-row{
  margin: 0px !important;
}
/deep/ .base-main{
  padding: 0px !important;
}

/deep/ #hycontent{
  background: #F0F2F5;
}

.theme_color {
  background-color: #ffffff;
}
#app {
  background: #f5f5f5;
}
@media print{
  #app {
    height : auto !important;
  }
  .base-main{
    background: #ffffff !important;
    padding: 0px !important;
  }
}
.base-main {
  // background-color: #e9eef3;
  background-color: #ffffff;
  min-width: 1024px;
  padding:6px 20px 6px 20px;
}

.base-footer {
  border-top: 1.5px solid #ededed;
}

.el-dialog__header {
  padding: 10px !important;
  background: #f8f8f8;
  border-bottom: 1px solid #eee;
}

.el-dialog__header > .el-dialog__title {
  font-size: 15px;
}

.el-dialog__header > .el-dialog__headerbtn {
  top: 13px;
}

.el-dialog__header .el-dialog__close {
  font-weight: bold;
}

.el-dialog__footer {
  border-top: 1px solid #eee;
}

.rotating {
  animation: rotating 1.7s linear infinite;
}
.indexMenu > div{
  float:left !important;
}
.el-menu-item{
    font-size: 14px !important;
}
</style>
